import { CategoriesState, CategoriesAction, CategoriesActionTypes } from './categoriesTypes';

const initialState: CategoriesState = {
  loadingCategories: true,
  savingCategory: false,
  removingCategory: false,
  categories: [],
  selectedIndex: null,
  isEditing: false,
};

export default function categoriesReducer(
  state = initialState,
  action: CategoriesAction,
): CategoriesState {
  switch (action.type) {
    case CategoriesActionTypes.EDITING_START:
      return {
        ...state,
        isEditing: true,
        selectedIndex: action.index ?? null,
      };

    case CategoriesActionTypes.EDITING_CANCEL:
      return {
        ...state,
        isEditing: false,
      };

    case CategoriesActionTypes.GET_CATEGORIES_START:
      return {
        ...state,
        loadingCategories: true,
      };

    case CategoriesActionTypes.GET_CATEGORIES_SUCCESS:
      if (!action.categories) {
        throw new Error();
      }
      return {
        ...state,
        loadingCategories: false,
        categories: action.categories,
      };

    case CategoriesActionTypes.GET_CATEGORIES_ERROR:
      return {
        ...state,
        loadingCategories: false,
      };

    case CategoriesActionTypes.SAVE_CATEGORY_START:
      return {
        ...state,
        savingCategory: true,
      };

    case CategoriesActionTypes.SAVE_CATEGORY_SUCCESS:
      return {
        ...state,
        savingCategory: false,
        selectedIndex: null,
      };

    case CategoriesActionTypes.SAVE_CATEGORY_ERROR:
      return {
        ...state,
        savingCategory: false,
        selectedIndex: null,
        isEditing: false,
      };

    case CategoriesActionTypes.REMOVE_CATEGORY_START:
      return {
        ...state,
        removingCategory: true,
      };

    case CategoriesActionTypes.REMOVE_CATEGORY_SUCCESS:
      return {
        ...state,
        removingCategory: false,
        selectedIndex: null,
        isEditing: false,
      };

    case CategoriesActionTypes.REMOVE_CATEGORY_ERROR:
      return {
        ...state,
        removingCategory: false,
        selectedIndex: null,
        isEditing: false,
      };

    case CategoriesActionTypes.CLEAR:
      return initialState;

    default:
      return state;
  }
}
